import {useState, useEffect} from 'react'
import PinNumber from './PinNumber'
import Questions from './Questions'
import {
  GETCLIENTFEATUREFLAGS,
  GET_CUSTOMER_INFO_BY_PINCODE,
  GET_USER_PROFILE,
} from '../../../utils/GraphQLAPI'
import {useLazyQuery} from '@apollo/client'
import {KTCard} from '../../../_metronic/helpers'
import CustomerInfo from '../SharedPages/TPVRecordingList/CustomerDetails/CustomerInfo'
import {GLOBAL_CONSTANTS} from '../../../utils/GlobalConstants'

const LiveAgentsCall = () => {
  const [pincode, setPincode] = useState()
  const [details, setDetails] = useState({
    clientName: '',
  })
  const [index, setIndex] = useState(1)
  const [isverified, setIsVerified] = useState(false)
  const [userData, setUserData] = useState<any>()
  const [customerData, setCustomerData] = useState<any>(null)
  const [canEdit, setCanEdit] = useState<boolean>(false)
  // Fetch User Profile Data
  const [getUserProfile] = useLazyQuery(GET_USER_PROFILE, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      getEntityName: true,
    },
    onCompleted: async (userData) => {
      window.localStorage.setItem('userId', JSON.stringify(userData?.getUserProfile?.id))
      setUserData(userData.getUserProfile)
    },
  })
  const [getClientFeatureflags, {data: featureFlags}] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const [getCustomerInfo] = useLazyQuery(GET_CUSTOMER_INFO_BY_PINCODE, {
    onCompleted: (data) => {
      setCustomerData(data?.getCustomerInfoByPin)
      getClientFeatureflags({
        variables: {
          customerId: data?.getCustomerInfoByPin?.id,
        },
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getUserProfile()
  }, [])

  const handleCustomerInfoSubmit = () => {
    setCustomerData(null)
    getCustomerInfo({
      variables: {
        pincode,
      },
    })
  }

  return (
    <>
      <div className='d-flex flex-stack container-fluid mb-5' id='kt_app_toolbar_container'>
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>Live Agent Call</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - Live Agent Call</span>
        </div>
      </div>

      {isverified ? (
        <>
          <Questions
            index={index}
            setIndex={setIndex}
            setPincode={setPincode}
            pincode={pincode}
            setIsVerified={setIsVerified}
            customerName={`${customerData?.firstName} ${customerData?.lastName}`}
            details={details}
            cardClassName={'mt-5 p-5'}
            rulesSection={
              <KTCard className={'h-100 mt-5 align-items-center py-3'}>
                <h4 className='text-center'>Rules</h4>
                <ul>
                  <li>
                    <h6>Clear Yes or No</h6>
                  </li>
                  <li>
                    <h6>Type in other for all other answers</h6>
                  </li>
                </ul>
              </KTCard>
            }
          />
          {canEdit && (
            <KTCard className='mt-5'>
              <CustomerInfo
                data={customerData}
                handleSubmitted={handleCustomerInfoSubmit}
                ediStatus='INCOMPLETE'
                featureFlags={featureFlags}
                showAudit={false}
                showMapAndDistance={false}
              />
            </KTCard>
          )}
        </>
      ) : (
        <PinNumber
          userName={userData ? `${userData.firstName} ${userData.lastName}` : 'user Name'}
          setIndex={setIndex}
          pincode={pincode}
          setPincode={setPincode}
          setIsVerified={setIsVerified}
          setDetails={setDetails}
          getCustomerInfo={getCustomerInfo}
          setCanEdit={setCanEdit}
        />
      )}
    </>
  )
}

export default LiveAgentsCall
